import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { AnalyticsEventFeatures } from '../../../typings/analytics';
import { PAGE_FUNCTION, PAGE_NAME, SUB_FUNCTION } from '../../../const/analytics';
import MainContext from '../../../Context';
import usePaymentFlowMachine from '../../../hooks/machines/usePaymentFlowMachine';
import useAnalyticsEventV2Creators from '../../../hooks/useAnalyticsEventV2Creators';
import { getAnalyticsMessageType } from '../../../machines/helpers';
import PaymentFailed from '../../molecules/PaymentModalStates/PaymentFailed';
import PayoffPaymentConfirmation from '../../molecules/PaymentModalStates/payoffPayment/PayoffPaymentConfirmation';
import PayoffPaymentForm from '../../molecules/PaymentModalStates/payoffPayment/PayoffPaymentForm';
import PayoffPaymentReview from '../../molecules/PaymentModalStates/payoffPayment/PayoffPaymentReview';
const PayoffPayment = ({ resetTabFocus }) => {
    const [, payoffPaymentActor] = usePaymentFlowMachine();
    const { createStartEventObject } = useAnalyticsEventV2Creators(AnalyticsEventFeatures.MAKE_A_PAYMENT);
    const { triggerAnalyticsEvent } = useContext(MainContext);
    useEffect(() => {
        resetTabFocus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [payoffPaymentActor.value]);
    useEffect(() => {
        const messageType = getAnalyticsMessageType(payoffPaymentActor.context.apiMachineRef);
        const eventOptionsV1 = Object.assign({ pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.PAYMENTS, pageSubFunction: SUB_FUNCTION.MAKE_PAYMENT.PAYMENT, pageName: PAGE_NAME.START }, (messageType && { messageType }));
        const eventOptionsV2 = createStartEventObject();
        triggerAnalyticsEvent(eventOptionsV1, eventOptionsV2);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (payoffPaymentActor.matches('edit')) {
        return _jsx(PayoffPaymentForm, {});
    }
    if (payoffPaymentActor.matches('review') ||
        payoffPaymentActor.matches('submitting')) {
        return _jsx(PayoffPaymentReview, {});
    }
    if (payoffPaymentActor.matches('success')) {
        return _jsx(PayoffPaymentConfirmation, {});
    }
    if (payoffPaymentActor.matches('error')) {
        return _jsx(PaymentFailed, {});
    }
    return null;
};
export default PayoffPayment;
